<template>
  <div class="officialDoc">
    <div class="top">
      <div class="form">
        <div class="form-row">
          <div class="row-item">
            <span>服务单号</span>
            <el-input v-model="form.orderNo" placeholder="请输入服务单号"></el-input>
          </div>
          <div class="row-item">
            <span>申请号</span>
            <el-input v-model="form.applyNo" placeholder="请输入申请号"></el-input>
          </div>
          <div class="row-item">
            <span>申请人</span>
            <el-input v-model="form.applyPerson" placeholder="请输入申请人姓名"></el-input>
          </div>
          <div class="row-item">
            <span>官文类型</span>
            <el-select placeholder="请选择" v-model="form.orderType">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                style="height:30px;font-size:12px;font-family:MicrosoftYaHei;line-height:30px;"
              ></el-option>
            </el-select>
          </div>
          <div class="row-item">
            <span>收文时间</span>
            <el-date-picker
              v-model="form.formTime"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="changeDate"
              :clearable ='false'
              value-format="yyyy-MM-dd"
              style="width:75%;height:30px;float:left;"
            ></el-date-picker>
          </div>
        </div>
        <div class="form-row">
          <div class="row-item">
            <span class="search" @click="search">查询</span>
            <span class="reset" @click="reset">重置</span>
          </div>
        </div>
      </div>
      <!-- <div class="btn-box">
        <p @click="downLoad">批量下载</p>
      </div>-->
    </div>
    <div class="content">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        :header-cell-style="tableClass"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column type="selection" width="50px;"></el-table-column>
        <el-table-column prop="serviceNo" label="服务单号" width="200px"></el-table-column>
        <el-table-column prop="askforId" label="申请号"></el-table-column>
        <el-table-column label="类别">
          <template slot-scope="scope">
            <!-- <span
              style="display:inline-block;padding:0 10px;width:100%;"
              v-for="(item,index) in scope.row.tradeType"
              :key="index"
            >第{{item.code||'--'}}类 {{item.name||'--'}}</span>-->
            <span>第{{scope.row.tmType||'--'}}类</span>
          </template>
        </el-table-column>
        <el-table-column label="商标图样">
          <template slot-scope="scope">
            <img :src="scope.row.tmPicUrl" alt style="width:100%;height:100%;" />
          </template>
        </el-table-column>
        <el-table-column prop="applicantName" label="申请人"></el-table-column>
        <el-table-column prop="fileType" label="官文类型"></el-table-column>
        <el-table-column prop="received_at" label="更新时间" sortable></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              align="center"
              @click="downloadFile(scope.row.serviceNo,scope.row.dir)"
            >下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <b>共{{total}}条</b>
      <div>
        <span class="demonstration">调整每页显示条数</span>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="10"
          layout="sizes, prev, pager, next"
          :total="total"
          style="display:inline-block;"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getOfficalList } from "@/api/fill.js";
export default {
  data() {
    return {
      loading: true,
      currentPage: 1,
      total: 0, //数据总数
      form: {
        // 表单数据中服务单号数据
        orderNo: "",
        // 表单数据中申请号数据
        applyNo: "",
        // 表单数据中申请人数据
        applyPerson: "",
        // 表单数据中官文类型数据
        orderType: "",
        // 表单数据中的更新时间数据
        formTime: "",
        // 表单数据中开始时间
        startTime: "",
        // 表单数据中结束时间
        endTime: "",
      },
      //下拉框选项
      options: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "受理通知书",
          label: "受理通知书",
        },
        {
          value: "初审公告",
          label: "初审公告",
        },
        {
          value: "商标注册证",
          label: "商标注册证",
        },
      ],
      // 表格数据
      tableData: [],
      formInline: {
        user: "",
        region: "",
      },
      multipleSelection: [],
      downLoadFiles: [],
      // 每页展示数据条数
      pageSize: 10,
    };
  },
  created() {
    let orderNo = this.$route.query.orderNo || "";
    this.getTableDate(orderNo);
  },
  computed: {
    // 修改表头背景色
    tableClass() {
      return { background: "rgba(247,252,255,1)", border: "none" };
    },
  },
  methods: {
    // 下载文件
    downloadFile(fileName, res) {
      // let tmpFileName=fileName+'.pdf'
      // let link = document.createElement("a");
      // link.style.display = "none";
      // link.href = res;
      // link.setAttribute("download", tmpFileName); // 文件名
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link); // 下载完成移除元素
      window.open(res)
    },
    // 请求驳回复审表格数据
    getTableDate(
      orderNo, //单号(空)
      askforId, //申请码(空)
      applicantName, //申请人(空)
      fileType, // N 订单状态(空)
      pageIndex, // Y 当前页(默认为1)
      pageSize, // Y 每页大小(默认为10)
      startTime, // N 开始时间(空)
      entTime // N 结束时间(空)
    ) {
      let params = {
        orderNo, //单号
        askforId, //申请码
        applicantName, //申请人
        fileType, // N 订单状态
        pageIndex: pageIndex || 1, // Y 当前页{
        pageSize: this.pageSize || 10, // Y 每页大小，最大为50
        startTime, // N 开始时间
        entTime, // N 结束时间
      };
      this.loading = true;
      getOfficalList(params).then((res) => {
        if (res.status === 0) {
          this.loading = false;
          this.tableData = res.data.map((item, index) => {
            item.received_at = this.formatTime(item.received_at);
            return item;
          });
          this.total = res.dataCount;
        } else {
          this.$message.error("数据请求失败");
        }
      });
    },
    // 查询数据
    search() {
      // 校验输入信息是否全为空
      let emptyNum = 0;
      for (let key in this.form) {
        if (this.form[key] == "") {
          emptyNum++;
        }
      }
      // 如果全为空，则不请求
      if (emptyNum == 7) {
        this.$message.error("请输入有效信息！");
      } else {
        this.currentPage = 1;
        if (this.form.orderType === "全部") {
          this.form.orderType = "";
        }
        this.getTableDate(
          this.form.orderNo, //查询单号
          this.form.applyNo, //查询申请号
          this.form.applyPerson, //查询申请人
          this.form.orderType, //查询订单状态
          1, //当前页(1)
          this.pageSize, //每页大小
          this.form.startTime, //开始(更新)时间
          this.form.endTime //结束时间()
        );
      }
    },
    // 重置查询数据
    reset() {
      this.form.orderNo = "";
      this.form.applyNo = "";
      this.form.applyPerson = "";
      this.form.orderType = "";
      this.form.formTime = "";
      this.form.startTime = "";
      this.form.endTime = "";
      this.getTableDate()
    },
    // 格式时间
    formatTime(timeStr) {
      let time = "--";
      if (timeStr) {
        if (timeStr.indexOf("T") !== -1) {
          let tmpStr = timeStr.split("T");
          let tmpYMD = tmpStr[0];
          let tmpHMS = tmpStr[1].split(".")[0];
          time = tmpYMD + " " + tmpHMS;
        } else {
          time = timeStr;
        }
      }
      return time;
    },
    // 监听时间输入框数据变化
    changeDate(e) {
      // 格式时间
      if(e){
        this.form.startTime = e[0]
        this.form.endTime = e[1]
      }
    },
    // 修改每页展示条数
    handleSizeChange(pageSize) {
      // console.log("每页展示条数变了", pageSize);
      this.pageSize = pageSize;
      this.getTableDate(
        this.form.orderNo, //查询单号
        this.form.applyNo, //查询申请号
        this.form.applyPerson, //查询申请人
        this.form.orderType, //查询订单状态
        1, //当前页(1)
        this.pageSize, //每页大小
        this.form.startTime, //开始(更新)时间
        this.form.endTime //结束时间()
      );
    },
    // 监听当前页
    handleCurrentChange() {
      // console.log("当前页变了", this.currentPage2);
      this.getTableDate(
        this.form.orderNo, //查询单号
        this.form.applyNo, //查询申请号
        this.form.applyPerson, //查询申请人
        this.form.orderType, //查询订单状态
        this.currentPage, //当前页
        this.pageSize, //每页大小
        this.form.startTime, //开始(更新)时间
        this.form.endTime //结束时间()
      );
    },
    // 下载
    downLoad() {
      // console.log("下载", this.downLoadFiles);
      let downLoadFiles = this.multipleSelection.map((item, index) => {
        return item.dir;
      });
      console.log(downLoadFiles);
    },
    // 表格每一行的选中事件
    select(selection, row) {
      // console.log(row, "kkkkkkkkkkkkk");
      // 如果未勾选，点击勾选，添加到下载文件数组
      if (this.downLoadFiles.indexOf(row.id) == -1) {
        this.downLoadFiles.push(row.id);
      } else {
        // 如果已勾选，从下载文件数组中删除文件
        let index = this.downLoadFiles.indexOf(row.id);
        this.downLoadFiles.splice(index, 1);
      }
    },
    // 全选按钮
    selectAll(selection) {
      // console.log(selection,'***************')
    },
    // 切换表格选中状态
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 监听表格每一行的选中状态
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
  },
};
</script>
<style lang="scss" scoped>
.officialDoc {
  width: 98%;
  position: absolute;
  top: 20px;
  bottom: 13px;
  overflow: auto;
  left: 50%;
  transform: translateX(-50%);

  .top {
    width: 100%;
    position: absolute;
    top: 0;
    height: 191px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    .form {
      width: 100%;
      padding-bottom: 20px;
      position: absolute;
      top: 0;
      border-spacing: 20px;
      border-collapse: separate;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
      .form-row {
        width: 100%;
        display: flex;
        margin-top: 20px;
        justify-content: flex-start;
        .row-item {
          display: flex;
          flex-wrap: nowrap;
          float: left;
          width: 18%;
          justify-content: space-evenly;
          /deep/.el-date-editor {
            .el-input__inner {
              padding-left: 30px !important;
            }
            .el-input__icon {
              line-height: 24px;
              margin-left: -10px;
            }
            .el-range-separator {
              line-height: 24px;
              width: 10%;
            }
            .el-input__prefix {
              top: -5px;
            }
          }
          .el-select {
            width: 70%;
          }

          /deep/.el-input__inner {
            border-radius: 0px;
            width: 100%;
            height: 30px;
            padding-left: 10px;
          }
          /deep/.el-input__icon {
            &.el-icon-time {
              display: none;
            }
          }
          /deep/.el-input__suffix {
            .el-select__caret {
              line-height: 30px;
            }
            .el-input__suffix-inner {
              .el-icon-circle-close {
                height: 30px;
                line-height: 30px;
              }
            }
          }
          span {
            display: inline-block;
            padding: 0 5px;
            height: 30px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(136, 136, 136, 1);
            line-height: 30px;
            overflow: hidden;
            white-space: nowrap;
          }
          .search {
            height: 30px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            line-height: 30px;
            width: 75px;
            background: rgba(0, 110, 255, 1);
          }
          .search:hover {
            cursor: pointer;
          }
          .reset {
            width: 75px;
            height: 30px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            text-align: center;
            line-height: 30px;
            margin-right: 20px;
            border: 1px solid rgba(221, 221, 221, 1);
          }
          .reset:hover {
            cursor: pointer;
          }
          select {
            width: 60%;
            height: 30px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(221, 221, 221, 1);
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(0, 0, 0, 1);
            line-height: 16px;
            text-indent: 6px;
            .select-item {
              height: 30px;
              width: 100%;
              line-height: 30px;
              font-size: 12px;
            }
          }
          .el-input {
            height: 30px;
            width: 70%;
          }
        }
      }
      .form-row:nth-of-type(1) {
        .row-item:nth-of-type(5) {
          width: 28%;
        }
      }
      .form-row:nth-of-type(2) {
        justify-content: flex-end;
      }
    }
    .btn-box {
      display: flex;
      width: 100%;
      justify-content: flex-start;
      height: 70px;
      align-items: center;
      position: absolute;
      top: 120px;
      p {
        width: 88px;
        height: 30px;
        text-align: center;
        line-height: 28px;
        display: inline-block;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        background-color: #006eff;
        cursor: pointer;
      }
      /deep/.router-link-exact-active {
        &.sel {
          color: rgba(2, 160, 234, 1);
        }
      }
    }
  }

  .content {
    position: absolute;
    top: 141px;
    bottom: 70px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    overflow: auto;
    /deep/.el-table {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
      overflow: auto;
      td {
        padding: 7px 0;
      }
      .el-table__header-wrapper {
        position: sticky;
        width: 100%;
        top: 0;
        z-index: 3;
        .el-table__header {
          /deep/.has-gutter {
            tr {
              .el-table_2_column_14 {
                padding-left: 4px;
              }
              th {
                padding: 8.5px 0;
              }
              th:nth-of-type(1) {
                padding: 8.5px 3px;
              }
            }
          }
        }
      }
    }
    .el-table::before {
      left: 0;
      bottom: 0;
      width: 100%;
      height: 0px;
    }
  }
  .block {
    margin: 0;
    height: 67px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 3px;
    padding-left: 14px;
    background: #ffffff;
    border-top: 1px solid rgba(229, 229, 229, 1);
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    div {
      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(136, 136, 136, 1);
        line-height: 17px;
        display: inline-block;
      }
    }
  }
}
</style>